export default __webpack_public_path__ + "static/media/loader-logo-w.4172af74.png";